import axios from 'axios';

import {
  geocoderApiUrl,
  geocoderCustomerKey,
  geocoderPrivateKey,
} from '../constants';

const geocodeAddress = async ({
  country = 'COL',
  city,
  state,
  address,
}) => new Promise((resolve, reject) => {
  axios.get(`${geocoderApiUrl}/geocoder/provider-selection`, {
    params: {
      country,
      city,
      state,
      address,
      provider: 'GOOGLE',
    },
    headers: {
      'customer-key': geocoderCustomerKey,
      'private-key': geocoderPrivateKey,
    },
  })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error));
});

export default geocodeAddress;
